
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M331.294118 512c0-18.070588 12.047059-30.117647 30.117647-30.117647h150.588235V240.941176c0-33.129412-27.105882-60.235294-60.235294-60.235294H210.823529c-33.129412 0-60.235294 27.105882-60.235294 60.235294v542.117648c0 33.129412 27.105882 60.235294 60.235294 60.235294h240.941177c33.129412 0 60.235294-27.105882 60.235294-60.235294v-240.941177h-150.588235c-15.058824 0-30.117647-12.047059-30.117647-30.117647z m536.094117-18.070588l-171.670588-150.588236c-30.117647-27.105882-60.235294 0-60.235294 33.129412V481.882353h-120.470588v60.235294h120.470588v105.411765c0 36.141176 27.105882 60.235294 60.235294 33.129412l171.670588-150.588236c6.023529-12.047059 6.023529-24.094118 0-36.141176z"
      }
    }
  ]
})
    }
  